import { combineReducers } from '@reduxjs/toolkit';
import { connectRouter } from 'connected-react-router';

import authReducer from 'features/auth/authSlice';
import uiPrefReducer from 'navigation/utils/navigationSlice';
import { FAQModalReducer } from 'navigation/utils/navigationSlice';
import { RxProgressReducer } from 'navigation/menu/rx-progress-slice';
import { TypedUseSelectorHook, useSelector } from 'react-redux';

export interface ConnectRouterState {
  lastAction?: 'resetPassword';
}

const createRootReducer = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    auth: authReducer,
    uiPref: uiPrefReducer,
    rxProgressBarPref: RxProgressReducer,
    faqModalPref: FAQModalReducer
  });

export type RootState = ReturnType<ReturnType<typeof createRootReducer>>;

/**
 * @deprecated Do not use this state management if possible.
 */
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export default createRootReducer;
